import { type ServiceConfig } from '../../ServiceRegistry';
import BaseService from '@/services/BaseService';
import { CompanyService } from '@/services/dealcard/CompanyService';
import { DealService } from '@/services/dealcard/DealService';
import { GenericService } from '@/services/dealcard/GenericService';
import { PersonService } from '@/services/dealcard/PersonService';
import { InvestorService } from '@/services/InvestorService';

/**
 * Dealcard service configurations
 * These services are used by the dealcard module and its federated components
 */
export const dealcardServices: ServiceConfig[] = [
  {
    name: 'baseService',
    factory: () => new BaseService('/api/deals'),
  },
  {
    name: 'companyService',
    factory: () => new CompanyService(),
  },
  {
    name: 'dealService',
    factory: () => new DealService(),
  },
  {
    name: 'personService',
    factory: () => new PersonService(),
  },
  {
    name: 'genericService',
    factory: () => new GenericService('/api/deals', 'generic'),
  },
  {
    name: 'investorService',
    factory: () => new InvestorService(),
  },
];

/**
 * Dealcard-specific service factory
 * Creates a custom service with dealcard-specific configuration
 */
export const createDealcardCustomService = (serviceName: string, baseUrl: string = '/api/deals'): ServiceConfig => ({
  name: serviceName,
  factory: () => new BaseService(baseUrl),
});

/**
 * Dealcard service utilities
 */
export const dealcardServiceUtils = {
  /**
   * Get all dealcard service names
   */
  getServiceNames: () => dealcardServices.map(s => s.name),

  /**
   * Check if a service name is a dealcard service
   */
  isDealcardService: (name: string) => dealcardServices.some(s => s.name === name),

  /**
   * Get dealcard base path
   */
  getBasePath: () => '/securitization/dealcard',
};
